import React from 'react';

const TermsNConditions = React.lazy(() => import('./TermsNConditions'));
const PrivacyPolicy = React.lazy(() => import('./PrivacyPolicy'));

export const cmsRouteConfigs = [
  {
    path: '/terms-and-conditions',
    element: <TermsNConditions />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },
];
